import { IGigPayoutsUpload } from "store/wh-partner-services/whPartnerServicesSlice";

const PERSIST_KEY = "wh_partner_alter_earnings_processing";

export const persistWhProcessingAlterEarnings = (data: IGigPayoutsUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting WH Alter Earnings data:", error);
  }
};

export const getPersistedWhProcessingAlterEarnings = (): IGigPayoutsUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving WH Alter Earnings data:", error);
    return {};
  }
};

export const removePersistedWhProcessingAlterEarnings = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing WH Alter Earnings data:", error);
  }
};
